document.addEventListener('DOMContentLoaded', function () {
	// $('.custom-select').click(function (e) {
	// 	if (!$(e.target).hasClass('option')) {
	// 		$(this).toggleClass('open')
	// 		$(this).find('.dropdown').toggleClass('open')
	// 	} else {
	// 		$(this).toggleClass('open')
	// 		$(this).find('.dropdown').toggleClass('open')
	// 		$('.selected').text(`${$(e.target).text()}`)
	// 	}
	// })

	const selects = document.querySelectorAll('.custom-select')

	selects.forEach(select => {
		// console.log(select)
		const trigger = select.querySelector<HTMLElement>('.trigger')!
		const optionsHolder = select.querySelector<HTMLElement>('.options')!
		const options =
			optionsHolder.querySelectorAll<HTMLOptionElement>('.option')!
		const selectedValue = select.querySelector<HTMLElement>('.selected')!
		const input = select.querySelector<HTMLInputElement>('input')!

		function updateSelectedValue(value = '', label = '') {
			selectedValue.textContent = label
			// console.log({ value, label })

			if (value === 'other') {
				input.value = ''
				input.type = 'text'
				input.focus()
			} else {
				input.type = 'hidden'
				input.value = value
				input.dispatchEvent(new Event('change'))
			}
		}

		function toggleOpen(force?: boolean) {
			const expanded =
				force === undefined
					? trigger.getAttribute('aria-expanded') === 'true'
					: !force

			optionsHolder.style.display = expanded ? 'none' : 'block'
			trigger.setAttribute('aria-expanded', (!expanded).toString())
		}

		trigger.addEventListener('click', e => {
			// console.log(e)
			e.preventDefault()
			e.stopPropagation()
			toggleOpen()
		})

		options.forEach(option =>
			option.addEventListener('click', () => {
				updateSelectedValue(
					option.dataset.value,
					option.textContent?.trim() ?? ''
				)
				toggleOpen(false)
			})
		)

		document.addEventListener('click', e => {
			if (e.target instanceof Element && !select.contains(e.target)) {
				toggleOpen(false)
			}
		})
	})
})
